import { apiClient } from '@features/shared/api/client'
import { chatAttachmentWithAbsoluteLinks } from './chatAttachments.api'
import type {
  ChatThreadDetail,
  ChatThreadSearchResponse,
  ChatThreadsResponse,
  RenameChatThreadRequest,
} from './contracts'

export async function getChatThreads(): Promise<ChatThreadsResponse> {
  const { data } = await apiClient.get<ChatThreadsResponse>('/assistant/threads')
  return data
}

export async function getChatThread(threadId: string): Promise<ChatThreadDetail> {
  const { data } = await apiClient.get<ChatThreadDetail>(
    `/assistant/threads/${encodeURIComponent(threadId)}`
  )
  return {
    ...data,
    messages: data.messages.map((message) =>
      message.attachments?.length
        ? { ...message, attachments: message.attachments.map(chatAttachmentWithAbsoluteLinks) }
        : message
    ),
  }
}

export async function renameChatThread(
  threadId: string,
  payload: RenameChatThreadRequest
): Promise<ChatThreadsResponse> {
  const { data } = await apiClient.patch<ChatThreadsResponse>(
    `/assistant/threads/${encodeURIComponent(threadId)}`,
    payload
  )
  return data
}

export async function deleteChatThread(threadId: string): Promise<ChatThreadsResponse> {
  const { data } = await apiClient.delete<ChatThreadsResponse>(
    `/assistant/threads/${encodeURIComponent(threadId)}`
  )
  return data
}

export async function searchChatThreads(query: string): Promise<ChatThreadSearchResponse> {
  const { data } = await apiClient.get<ChatThreadSearchResponse>('/assistant/threads/search', {
    params: { q: query },
  })
  return data
}
